import Vue from 'vue'
import Router from 'vue-router'
import FrontPage from '../components/FrontPage'
// import Search from '../components/Search'
import Search from '../components/Search'
import Status from '../components/Status'

Vue.use(Router)

export default new Router({
//   mode: 'history',
  routes: [
    {
      path: '/',
      name: '/',
      component: FrontPage
    },
    {
      path: '/search',
      name: 'search',
      component: Search,
      props: (route) => ({ q: route.query.q, f: route.query.f })
    },
    {
      path: '/status',
      name: 'status',
      component: Status,
      props: (route) => ({ q: route.query.q })
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js